import { useMergeRefs } from "@floating-ui/react";
import { forwardRef, type HTMLProps } from "react";
import { useTooltipContext } from "./TooltipContext";

export const TooltipTrigger = forwardRef<
  HTMLDivElement,
  HTMLProps<HTMLDivElement>
>(({ children, className, ...props }, propRef) => {
  const context = useTooltipContext();
  const ref = useMergeRefs([context.refs.setReference, propRef]);

  return (
    <div
      ref={ref}
      className={className}
      data-state={context.open ? "open" : "closed"}
      {...context.getReferenceProps(props)}
    >
      {children}
    </div>
  );
});

TooltipTrigger.displayName = "TooltipTrigger";
